import { render, staticRenderFns } from "./PlanejamentoContrato.vue?vue&type=template&id=24a31b4e&"
import script from "./PlanejamentoContrato.vue?vue&type=script&lang=js&"
export * from "./PlanejamentoContrato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports